<template>
<div>
    <h3>Investigations{{type === 'search' ? ' Search' : ''}}</h3>
	<form v-if="type ==='search'" @submit.prevent="loadData" class="form-horizontal">
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchReportTitle">Report Title</label>
            </div>
            <div class="col-sm-5">
                <input class="form-control" type="text" name="searchReportTitle" v-model="searchDto.reportTitle">
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchDbNumber">DB Number</label>
            </div>
            <div class="col-sm-2">
                <input class="form-control" type="text" name="searchDbNumber" v-model="searchDto.dbNumber">
            </div>
            <div class="col-sm-2 col-sm-offset-1">
                <label for="searchRevNo">Rev No (legacy)</label>
            </div>
            <div class="col-sm-4">
                <input class="form-control" type="text" name="searchRevNo" v-model="searchDto.revNo">
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchAgencyNumber">Agency Number</label>
            </div>
            <div class="col-sm-2">
                <input class="form-control" type="text" name="searchAgencyNumber" v-model="searchDto.agencyNumber">
            </div>
            <div class="col-sm-2 col-sm-offset-1">
                <label for="searchAgencyName">Agency Name</label>
            </div>
            <div class="col-sm-5">
                <select name="searchAgencyName" class="form-control" v-model="searchDto.agencyName">
                    <option value="">Select Agency Name</option>
                    <option v-for="organization in leadOrganizationList" :key="organization.organizationId" :value="organization.description">{{ organization.description}}</option>
                </select>
            </div>
        </div>
            <div class="form-group">
                <div class="col-sm-2">
                    <label for="searchFieldOrgNumber">Field Org. Number</label>
                </div>
            <div class="col-sm-2">
                <input class="form-control" type="text" name="searchFieldOrgNumber" v-model="searchDto.fieldOrgNumber">
            </div>
            <div class="col-sm-2 col-sm-offset-1">
                <label for="searchFieldOrgName">Field Org. Name</label>
            </div>
            <div class="col-sm-5">
                <select name="searchFieldOrgName" class="form-control" v-model="searchDto.fieldOrgName">
                    <option value="">Select Field Organization Name</option>
                    <option v-for="organization in organizationList" :key="organization.organizationId" :value="organization.description">
                        {{ organization.description}}
                    </option>
                    </select>
                </div>
            </div>
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchProjectType">Project Type</label>
            </div>
            <div class="col-sm-3">
                <input class="form-control" type="text" name="searchProjectType" v-model="searchDto.projectType">
            </div>
            <div class="col-sm-2">
                <label for="searchClientName">Client Name</label>
            </div>
            <div class="col-sm-5">
                <select name="searchClientName" class="form-control" v-model="searchDto.clientName">
                    <option value="">Select Client Name</option>
                    <option v-for="organization in organizationList" :key="organization.organizationId" :value="organization.description">
                        {{ organization.description}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-2">
                <label for="searchProjectType">Status</label>
            </div>
            <div class="col-sm-3">
                <select class="form-control" name="workflowStatusId" v-model="searchDto.workflowStatusId">
                    <option :value="null">Select Workflow Status</option>
                    <option v-for="status in workflowList" :value="status.workflowStatusId" :key="status.workflowStatusId">{{status.description}}</option>
                </select>
            </div>
            <div class="col-sm-2">
                <label for="searchFieldOrgName">Report Date Range</label>
            </div>
            <div class="col-sm-2">
                <el-date-picker v-model="searchDto.startDate" type="date" format="MM/dd/yyyy" placeholder="From Date"></el-date-picker>
            </div>
            <div class="col-sm-2">
                <el-date-picker v-model="searchDto.endDate" type="date" format="MM/dd/yyyy" placeholder="To Date"></el-date-picker>
            </div>
        </div>
        <div class="form-group">
			<div class="col-sm-2">
				<label class="form-check-label" for="showInactive">Show Inactive Projects</label>
			</div>
			<div class="col-sm-3">
				<input class="form-check-input" type="checkbox" v-model="searchDto.showInactive" style="width: 20px; height: 20px;">
			</div>
            <div class="col-sm-2">
                <label for="searchFieldOrgName">SHPO Review Date Range</label>
            </div>
            <div class="col-sm-2">
                <el-date-picker v-model="searchDto.shpoReviewStartDate" type="date" format="MM/dd/yyyy" placeholder="From Date"></el-date-picker>
            </div>
            <div class="col-sm-2">
                <el-date-picker v-model="searchDto.shpoReviewEndDate" type="date" format="MM/dd/yyyy" placeholder="To Date"></el-date-picker>
            </div>
        </div>
		<div class="form-group form-check">
            <div class="col-sm-5"></div>
            <div class="col-sm-2">
                <label for="searchFieldOrgName">SHPO Reviewer</label>
            </div>
            <div class="col-sm-5">
                <select name="searchReviewerName" class="form-control" v-model="searchDto.reviewerId">
                    <option value="">Select Reviewer Name</option>
                    <option v-for="reviewer in reviewerList" :key="reviewer.userId" :value="reviewer.userId">
                        {{ reviewer.fullName}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group">
        </div>
		<div class="form-group">
			<div class="col-md-2">
				<button class="btn btn-primary" type="submit" name="button">Search</button>
			</div>
		</div>
	</form>
    <div class="wrapper">
        <div class="row row-wider">
            <div class="col-md-12">
                <loader v-if="loading" />
                <div class="col-md-2 form-group" v-if="isUserRc && type ==='todo'">
                    <div class="pull-right">
                        <input class="form-check-input" type="checkbox" v-model="searchDto.showAll" style="width: 20px; height: 20px;">
                    </div>
                    <div class="pull-right">
                        <label class="form-check-label" for="showAll">Show All&nbsp;</label>
                    </div>
                </div>
                <div>
                    <v-client-table :data="gridSpec.tableData" :columns="gridSpecColumns" :options="gridSpec.options">
                        <template slot="edit" slot-scope="props">
                            <div style="text-align: center;">
                                <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.investigationId)"></a> -->
                                <router-link :to="{ path: '/Investigation/' + props.row.investigationId, hash: '#siteSummary' }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                            </div>
                        </template>
                        <template slot="resources" slot-scope="props">
                            <div style="text-align: center;">
                                <span v-if="props.row.siteCount > 0 || props.row.isolateCount > 0">Yes&nbsp;</span>
                                <router-link :to="{ path: '/Investigation/' + props.row.investigationId, hash: '#siteSummary' }" tag="a" class="fa fa-edit" style="font-size: 16px;" v-if="props.row.siteCount > 0 || props.row.isolateCount > 0"></router-link>
                                <span v-else>No</span>
                            </div>
                        </template>
                        <template slot="daysRemainingUntilDeadline" slot-scope="props">
                            <div style="text-align: center;">
                                <span :style="getDaysRemainingStyle(props.row)">
                                    {{getDaysRemainingText(props.row)}}
                                </span>
                            </div>
                        </template>
                    </v-client-table>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import investigationService from '../services/investigationService'
import workflowService from '../services/workflowService'
import organizationService from '../services/organizationService'
import userService from '../services/userService'
import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    data () {
        return {
            isDebug: false,
            loading: true,
            leadOrganizationList: [],
            organizationList: [],
            reviewerList: [],
            searchDto: {
                dbNumber: '',
                reportTitle: '',
                agencyNumber: null,
                agencyName: '',
                clientName: '',
                fieldOrgNumber: null,
                fieldOrgName: '',
                projectType: '',
                startDate: null,
                endDate: null,
                shpoReviewStartDate: null,
                shpoReviewEndDate: null,
                reviewerId: '',
                workflowStatusId: null,
                showAll: false,
                showInactive: false,
                skipDeletable: true
            },
            gridSpec: {
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['reportDate'],
                    headings: {
                        edit: 'View/Edit',
                        workflowStatusDescription: 'Status',
                        workflowStatusDate: 'Status Date',
                        dbNumber: 'DB Number',
                        reportTitle: 'Report Title',
                        reportDate: 'Report Date',
                        isUserAssignedDisplay: 'Assigned',
                        assignedAgent: 'Assigned Agent',
                        isSiteAssignedDisplay: 'Site Assigned',
                        resources: 'Resources',
                        fieldOrgNumber: 'Field Org Number',
                        reviewTimeframe: 'Review Timeframe',
                        daysRemainingUntilDeadline: 'Days Until Due Date',
                        leadAgencyName: 'Agency',
                        agencyNumber: 'Agency No'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'workflowStatusDate'
                    }
                }
            },
            workflowList: []
        }
    },
    props: {
        type: {
            type: String,
            default: 'search'
        },
        isUserRc: { default: false }
    },
    computed: {
        gridSpecColumns: function () {
            var gridSpecColumns = [
                'edit',
                'workflowStatusDescription',
                'workflowStatusDate',
                'dbNumber',
                'leadAgencyName',
                'agencyNumber',
                'reportTitle',
                'reportDate']
            if (this.type === 'search') {
                loggingService.log(this.isDebug, 'Investigationss', 'computed.gridSpec.search')
                gridSpecColumns.push('fieldOrgNumber')
            } else if (this.type === 'todo') {
                loggingService.log(this.isDebug, 'Investigations', 'computed.gridSpec.todo')
                gridSpecColumns.push('isUserAssignedDisplay')
                gridSpecColumns.push('assignedAgent')
                gridSpecColumns.push('isSiteAssignedDisplay')
                gridSpecColumns.push('resources')
                gridSpecColumns.push('reviewTimeframe')
                gridSpecColumns.push('daysRemainingUntilDeadline')
            } else {
                loggingService.log(this.isDebug, 'Investigations', 'computed.gridSpec - unknown type: ' + this.type)
            }
            return gridSpecColumns
        }
    },
    watch: {
        'searchDto.showAll': function () {
            this.loadData()
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Investigations', 'mounted')
        this.loadData()
        this.loadWorkflow()
        this.loadLeadOrganizationList()
        this.loadOrganizations()
        this.loadReviewers()
    },
    methods: {
        loadData () {
            this.loading = true
            this.gridSpec.tableData = []
            if (this.type === 'search') {
                loggingService.log(this.isDebug, 'Investigations', 'loadData.search')
                investigationService.search(this.$http, this.searchDto).then(response => {
                    this.gridSpec.tableData = response.data
                    this.loading = false
                })
            } else if (this.type === 'todo') {
                loggingService.log(this.isDebug, 'Investigations', 'loadData.todo')
                investigationService.todo(this.$http, this.searchDto).then(response => {
                    this.gridSpec.tableData = response.data
                    this.loading = false
                })
            } else {
                loggingService.log(this.isDebug, 'Investigations', 'loadData - unknown type: ' + this.type)
            }
        },
        loadWorkflow () {
            workflowService.listByWorkflowId(this.$http, workflowService.WorkflowEnum.Investigation).then(result => {
                this.workflowList = result.data.reverse()
            })
        },
        loadLeadOrganizationList () {
            loggingService.log(this.isDebug, 'Investigations', 'loadLeadOrganizationList')
            this.leadOrganizationList = []
            var handle = this
            return organizationService.listLeadAgencyLookup(handle.$http).then(function (response) {
                handle.leadOrganizationList = response.data
            })
        },
        loadOrganizations () {
            loggingService.log(this.isDebug, 'Investigations', 'loadOrganizations')
            this.organizationList = []
            var handle = this
            return organizationService.listLookup(this.$http).then(function (response) {
                handle.organizationList = response.data
            })
        },
        loadReviewers () {
            loggingService.log(this.isDebug, 'Investigations', 'loadReviewers')
            this.reviewerList = []
            var handle = this
            return userService.listAllShpoUsers(this.$http).then(function (response) {
                handle.reviewerList = response.data
            })
        },
        editRow (id) {
            loggingService.log(this.isDebug, 'Investigations', 'editRow, id: ' + id)
            this.$router.push('/Investigation/' + id)
        },
        getDaysRemainingText (inv) {
            if (inv.workflowStatusDescription === 'Pending Consultant Data Entry' ||
            inv.workflowStatusDescription === 'Pending Agency Review' || inv.hasPendingSites) {
                return 'Pending'
            } else if (inv.daysRemainingUntilDeadline > 0 && inv.daysRemainingUntilDeadline < 4) {
                return inv.daysRemainingUntilDeadline.toString() + ' Day' + (inv.daysRemainingUntilDeadline === 1 ? '' : 's') + ' Remaining'
            } else if (inv.daysRemainingUntilDeadline > 3) {
                return inv.daysRemainingUntilDeadline.toString() + ' Days Remaining'
            } else if (inv.daysRemainingUntilDeadline < 0) {
                return (-inv.daysRemainingUntilDeadline).toString() + ' Day' + (inv.daysRemainingUntilDeadline === 1 ? '' : 's') + ' Overdue'
            } else if (inv.daysRemainingUntilDeadline === 0) {
                return 'Due Today'
            }
            return ''
        },
        getDaysRemainingStyle (inv) {
            if (inv.workflowStatusDescription === 'Pending Consultant Data Entry' ||
            inv.workflowStatusDescription === 'Pending Agency Review' || inv.hasPendingSites) {
                return 'color: #dedb07'
            } else if (inv.daysRemainingUntilDeadline > 0 && inv.daysRemainingUntilDeadline < 4) {
                return 'color: orange'
            } else if (inv.daysRemainingUntilDeadline > 3) {
                return 'color: green'
            } else if (inv.daysRemainingUntilDeadline < 0) {
                return 'color: red'
            } else if (inv.daysRemainingUntilDeadline === 0) {
                return 'color: red'
            }
            return 'color: black'
        }
    }
}
</script>



// WEBPACK FOOTER //
// Investigations.vue?02967b05